let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8DxN8")).then(() => parcelRequire('1hCRG'));